<template>
<b-modal id="modalRegistarCarCode" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="closeScan" size="lg">
	<div class="fullscreen" v-if="show">
		
		<Loader :show="loading"></Loader>

		<div class="code-reader transition" >
			<div class="btn " @click="closeScan()" v-if="opened"><i class="icon icon-close invert"></i></div>
			<div class="layer transition" v-if="opened"></div>
			<qrcode-stream @decode="onDecode" @init="onInit" ref="rootElement"></qrcode-stream>
		</div>

	</div>
</b-modal>

</template>

<script>
import gql from 'graphql-tag'
import { QrcodeStream } from 'vue-qrcode-reader'
import Loader from '@/components/Loader'

export default {
	name: 'readCode',
	components:{
		Loader,
		QrcodeStream,
	},
	props:['title'],
	data () {
		return {
			loading: false,
			opened: false,
			show: false,
			beep: new Audio(require('@/assets/beep.mp3')),
			position:{ lat:'', lng:''}
		}
	},
	mounted(){
		this.watchLocation()
	},
	methods:{
		watchLocation(){
			console.log('watchLocation')
			// this.$getLocation({enableHighAccuracy: true, timeout: 5000})
			// .then(coordinates => {
			// 	this.position = {
			// 		lat: coordinates.lat,
			// 		lng: coordinates.lng,
			// 	}
			// 	console.log(this.position)
			// }).catch(err => {
			// 	console.log(err)
			// 	// this.$toast.error('Debe aceptar los permisos de ubicación')
			// })
			this.$watchLocation({enableHighAccuracy: true, timeout: 5000})
			.then(coordinates => {
				this.position = {
					lat: coordinates.lat,
					lng: coordinates.lng,
				}
			})
			.catch(err => {
				console.log(err)
				// this.$toast.error('Debe aceptar los permisos de ubicación')
			})
		},
		open() {
			this.show = true
			this.$bvModal.show('modalRegistarCarCode')
		},
		closeScan(){
			this.show = false
			this.$bvModal.hide('modalRegistarCarCode')
		},
		async onInit(promise){
			try{
				await promise
				this.opened = true
			} catch(error){
				console.log(error)
			}
		},
		onDecode(data){
			this.beep.play()
			
			data =  JSON.parse(data)
			if(data.id){
				this.setReadCar(data.id)
			}
			else{
				this.$toast.error('Código incorrecto')
				this.closeScan()
				return false 
			}
		},
		setReadCar(car_id){
			this.loading = true
			console.log(this.position)
			this.$apollo.mutate({
				mutation: gql`mutation ($id: ID!, $position: LatLngInput) {
					setReadCar (id: $id, position: $position) {
						id
						chassis_number
					}
				}`,
				variables: {
					id: car_id,
					position: this.position
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				if(!data.data.setReadCar.id){
					this.$toast.error('No se ha encontrado un vehículo con ese código')
				}else{
					this.$toast.success(`El vehículo ${data.data.setReadCar.chassis_number} se ha registrado correctamente`)
					
					// this.$router.push(`/control/${data.data.car.id}`)
				}
				this.closeScan()
				this.loading = false
			}).catch(()=>{
				this.$toast.error('Error al registrar vehículo')
				this.closeScan()
				this.loading = false
			})

		}
	}
}


</script>

<style scoped lang="scss">
.code-reader{
	width:100%;
	height:100%;
	z-index:100;
	top:0px;
	position:fixed;

	.btn{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 11;
		font-size:18px;
		color:	#fff;
	}
}
.layer{
	position:absolute;
	top:0;
	width:100%;
	height:100%;
	background:rgba(155,155,155,0.6) ;	
	z-index: 10;
	-webkit-clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
	clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
}
</style>
